import { type ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/utils/cn';
import type { NavItem } from './sidebar-link';
import { SidebarLabel } from './sidebar-label';
import { CHILD_CLS, CHILD_ON, CHILD_OFF } from './sidebar-styles';

export function ChildLink({
  item,
  collapsed,
}: {
  item: NavItem;
  collapsed: boolean;
}): ReactNode {
  return (
    <li>
      <NavLink
        to={item.to}
        title={item.label}
        end
        className={({ isActive }) =>
          cn(CHILD_CLS, isActive ? CHILD_ON : CHILD_OFF)
        }
      >
        <SidebarLabel item={item} collapsed={collapsed} />
      </NavLink>
    </li>
  );
}

export function Chevron({
  open,
  collapsed,
}: {
  open: boolean;
  collapsed: boolean;
}): ReactNode {
  if (collapsed) return null;
  return (
    <ChevronDown
      size={14}
      className={cn(
        'ml-auto shrink-0 transition-transform',
        open && 'rotate-180'
      )}
    />
  );
}
